import { render, staticRenderFns } from "./NewRirekishoResetDialog.vue?vue&type=template&id=348f90e3"
import script from "./NewRirekishoResetDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoResetDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewRirekishoResetDialog.vue?vue&type=style&index=0&id=348f90e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports